import { createSignal, Show } from 'solid-js'
import { signIn } from '../lib/session.ts'
import { createFormErrors } from '../prototype/lib/form-errors.ts'
import { Field, Input } from '../ui/index.ts'

export const SignIn = (props: { onSignedIn: () => Promise<unknown> }) => {
  const errors = createFormErrors()
  const [email, setEmail] = createSignal('')
  const [password, setPassword] = createSignal('')
  const [pending, setPending] = createSignal(false)
  const [error, setError] = createSignal('')
  const emailError = () =>
    !email().trim()
      ? 'Вкажіть електронну пошту'
      : !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email().trim())
        ? 'Вкажіть коректну електронну пошту'
        : ''
  const passwordError = () => (!password() ? 'Вкажіть пароль' : '')

  const submit = async (event: SubmitEvent) => {
    event.preventDefault()
    if (pending() || !errors.submit(!emailError() && !passwordError())) return
    setPending(true)
    setError('')
    try {
      await signIn(email().trim(), password())
      await props.onSignedIn()
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : 'Не вдалося увійти')
    } finally {
      setPending(false)
    }
  }

  return (
    <main class="grid min-h-dvh place-items-center bg-app px-4 py-10 text-text">
      <div class="grid w-full max-w-sm gap-7">
        <div class="flex items-center justify-center gap-3">
          <span class="grid size-10 place-items-center rounded-control bg-ink font-display text-caption font-bold text-text-inverse">
            АМ
          </span>
          <span class="font-display text-body font-bold tracking-tight">АМ-АВТОПРОМ</span>
        </div>
        <form
          onSubmit={submit}
          noValidate
          class="grid gap-5 rounded-panel border border-border bg-surface p-6 shadow-[0_1px_2px_oklch(0.196_0.007_265/0.04)]"
        >
          <div class="grid gap-1.5">
            <h1 class="font-display text-title font-bold">Вхід</h1>
            <p class="text-body text-text-muted">Увійдіть у свій робочий обліковий запис.</p>
          </div>
          <Field
            for="sign-in-email"
            label="Електронна пошта"
            error={errors.show('email') ? emailError() : undefined}
          >
            <Input
              id="sign-in-email"
              onBlur={() => errors.touch('email')}
              type="email"
              name="email"
              autocomplete="username"
              required
              value={email()}
              onInput={(event) => setEmail(event.currentTarget.value)}
              disabled={pending()}
            />
          </Field>
          <Field
            for="sign-in-password"
            label="Пароль"
            error={errors.show('password') ? passwordError() : undefined}
          >
            <Input
              id="sign-in-password"
              onBlur={() => errors.touch('password')}
              type="password"
              name="password"
              autocomplete="current-password"
              required
              value={password()}
              onInput={(event) => setPassword(event.currentTarget.value)}
              disabled={pending()}
            />
          </Field>
          <Show when={error()}>
            <p role="alert" class="text-body text-status-critical">
              {error()}
            </p>
          </Show>
          <button
            type="submit"
            disabled={pending()}
            class="flex h-10 items-center justify-center rounded-control bg-ink px-4 text-body font-semibold text-text-inverse transition-opacity hover:opacity-85 disabled:opacity-50"
          >
            {pending() ? 'Входимо…' : 'Увійти'}
          </button>
          <p class="text-caption text-text-subtle">Доступ надає адміністратор.</p>
        </form>
      </div>
    </main>
  )
}
